export var SecurePassAutoSend;
(function (SecurePassAutoSend) {
    SecurePassAutoSend[SecurePassAutoSend["DoNotSend"] = 1] = "DoNotSend";
    SecurePassAutoSend[SecurePassAutoSend["Default"] = 2] = "Default";
    SecurePassAutoSend[SecurePassAutoSend["Send"] = 3] = "Send";
})(SecurePassAutoSend || (SecurePassAutoSend = {}));
export var ScanStatuses;
(function (ScanStatuses) {
    ScanStatuses[ScanStatuses["NotScanned"] = 1] = "NotScanned";
    ScanStatuses[ScanStatuses["Success"] = 2] = "Success";
    ScanStatuses[ScanStatuses["Fail"] = 3] = "Fail";
    ScanStatuses[ScanStatuses["ManualSuccess"] = 4] = "ManualSuccess";
    ScanStatuses[ScanStatuses["ManualFail"] = 5] = "ManualFail";
})(ScanStatuses || (ScanStatuses = {}));
